
import React from 'react';
import { render } from 'react-dom';
import ConfirmComponent from './ComfirComponent';
/**
 * Confirm({})
 *
 * children           {jsx}       自定义内容
 * content            {string}    提示的内容
 * confirmText        {string}    确定按钮的文字
 * confirmCallback    {string}    确定之后的回调
 * cancelText         {func}      取消按钮的文字
 * cancelCallback     {func}      取消之后的回调
 */

let div = document.createElement('div');
document.body.appendChild(div);


const Confirm = (params = {}) => {
  if (!params.content) {
    params.content = '';
  }
  if (!params.confirmText && params.confirmText !== false) {
    params.confirmText = '确定';
  }
  if (!params.confirmCallback) {
    params.confirmCallback = () => {};
  }
  if (!params.cancelText && params.cancelText !== false) {
    params.cancelText = '取消';
  }
  if (!params.cancelCallback) {
    params.cancelCallback = () => {};
  }

  render(<ConfirmComponent {...params} />, div);
};


export default Confirm;



// WEBPACK FOOTER //
// ./src/components/Confirm/index.js